<!-- Header con operadora seleccionada -->
<div class="tipos-header">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
            <button type="button" class="btn btn-outline-secondary btn-sm me-3" (click)="onVolver()">
                <i class="fas fa-arrow-left me-2"></i>Volver
            </button>
            
            <div class="d-flex align-items-center">
                <div class="operadora-logo-small" *ngIf="operadora">
                    <img [src]="operadora.urlImag || '/assets/brandLogos/default.svg'" 
                         [alt]="operadora.name" 
                         class="logo-small"
                         (error)="onImageError($event)">
                </div>
                <div>
                    <h6 class="header-title mb-0">
                        <i class="fas fa-cogs me-2"></i>Tipos de Operación
                    </h6>
                    <small class="text-muted" *ngIf="operadora">{{ operadora.name }}</small>
                </div>
            </div>
        </div>
        
        <div class="operadora-badge">
            <span class="badge bg-primary">{{ operadoraCode }}</span>
        </div>
    </div>
</div>

<!-- Loading State -->
<div *ngIf="loading" class="loading-container">
    <div class="loading-content">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="loading-text">Cargando tipos de operación...</p>
    </div>
</div>

<!-- Error State -->
<div *ngIf="error && !loading" class="error-container">
    <div class="error-content">
        <i class="fas fa-exclamation-triangle error-icon"></i>
        <h5 class="error-title">Error al cargar tipos de operación</h5>
        <p class="error-message">{{ error }}</p>
        <button type="button" class="btn btn-primary btn-sm" (click)="onRetry()">
            <i class="fas fa-redo me-2"></i>Reintentar
        </button>
    </div>
</div>

<!-- Empty State -->
<div *ngIf="!loading && !error && tiposOperacion.length === 0" class="empty-container">
    <div class="empty-content">
        <i class="fas fa-cogs empty-icon"></i>
        <h5 class="empty-title">No hay tipos de operación disponibles</h5>
        <p class="empty-message">
            No se encontraron tipos de operación activos para <strong>{{ operadora?.name || operadoraCode }}</strong>.
        </p>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="onRetry()">
            <i class="fas fa-redo me-2"></i>Actualizar
        </button>
    </div>
</div>

<!-- Success State - Lista de Tipos de Operación -->
<div *ngIf="!loading && !error && tiposOperacion.length > 0" class="tipos-container">
    
    <!-- Header -->
    <div class="tipos-content-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h6 class="content-title">
                    <i class="fas fa-list me-2"></i>Seleccionar Tipo de Operación
                </h6>
                <p class="content-subtitle">
                    Seleccione el tipo de operación para <strong>{{ operadora?.name || operadoraCode }}</strong>
                </p>
            </div>
            <div class="header-count">
                <span class="badge bg-success">{{ tiposOperacion.length }} tipos disponibles</span>
            </div>
        </div>
    </div>

    <!-- Grid de Tipos de Operación -->
    <div class="tipos-grid">
        <div *ngFor="let tipo of tiposOperacion; trackBy: trackByCode" 
             class="tipo-card" 
             (click)="onSelectTipoOperacion(tipo)"
             [attr.data-code]="tipo.code">
            
            <!-- Icono del tipo -->
            <div class="tipo-icon">
                <i class="fas" 
                   [ngClass]="{
                     'fa-mobile-alt': tipo.code.toLowerCase().includes('pre'),
                     'fa-calendar-alt': tipo.code.toLowerCase().includes('post'),
                     'fa-credit-card': !tipo.code.toLowerCase().includes('pre') && !tipo.code.toLowerCase().includes('post')
                   }"></i>
            </div>

            <!-- Información del tipo -->
            <div class="tipo-info">
                <h5 class="tipo-name">{{ tipo.name }}</h5>
                <p class="tipo-description">{{ tipo.description }}</p>
                
                <!-- Estados -->
                <div class="tipo-status">
                    <span class="status-badge status-active" *ngIf="tipo.status">
                        <i class="fas fa-check-circle me-1"></i>Activo
                    </span>
                </div>
            </div>

            <!-- Indicador de navegación -->
            <div class="tipo-arrow">
                <i class="fas fa-chevron-right"></i>
            </div>

            <!-- Overlay de hover -->
            <div class="card-overlay"></div>
        </div>
    </div>

    <!-- Footer con información adicional -->
    <div class="tipos-footer">
        <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
                <i class="fas fa-info-circle me-1"></i>
                Haga clic en un tipo de operación para ver los productos disponibles
            </small>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onRetry()">
                <i class="fas fa-sync-alt me-2"></i>Actualizar
            </button>
        </div>
    </div>
</div> 